/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_PRESENTATIONS } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IPresentationListsMethods extends IPluginMethodMap {
  getPresentationListsProps(args: any): Promise<any>;
}

export class PresentationListsService implements IAgentPlugin {
  readonly methods: IPresentationListsMethods;

  constructor() {
    this.methods = {
      getPresentationListsProps: this.getPresentationListsProps.bind(this),
    };
  }

  async getPresentationListsProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        const res = await client.query({
          query: GET_PRESENTATIONS,
          variables: {
            filter: {},
            options: {
              limit: 0,
              skip: 0,
              sort: {
                field: "status",
                order: "asc",
              },
            },
          },
          fetchPolicy: "network-only",
        });
        console.log("get Presentation i sales report======", res?.data);
        return {
          // ...config,

          typeOfSearch: this.formatPresentations(
            res?.data?.getPresentations?.content
          ),
          defaultPresentations:
            args?.criteria?.presentation ??
            res?.data?.getPresentations?.content[0].id,
          searchStatusFilter: [
            {
              value: "AnyStatus",
              label: "Any Status",
            },
            {
              value: "Active",
              label: "Active",
            },
            {
              value: "Expired",
              label: "Expired",
            },
            {
              value: "Paused",
              label: "Paused",
            },
          ],
        };
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
  private formatPresentations(presentations: any[]): any {
    if (!presentations || presentations.length === 0) {
      return [];
    }

    console.log(presentations);
    const _rowData = presentations.map((presentation: any) => {
      return {
        label: presentation.name,
        value: presentation.id,
        year: presentation.year,
        status: presentation.status,
        section: presentation.sections.map((section: any) => {
          return {
            label: section.name,
            value: section.id,
            sectionOptType: section.costumeTypes.map((costumeType: any) => {
              return {
                label: costumeType.name,
                value: costumeType.id,
              };
            }),
          };
        }),
      };
    });

    console.log(_rowData, "rowData");
    return _rowData;
  }
}
